export default __webpack_public_path__ + "static/media/googlePay.66e24369.svg";